import React, { createContext, useContext, useState, useEffect } from 'react';
import { constantsAPI } from '@/services/api';

const ConstantsContext = createContext(null);

export const ConstantsProvider = ({ children }) => {
  const [constants, setConstants] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const fetchConstants = async () => {
      try {
        setLoading(true);
        const response = await constantsAPI.getAll();
        if (isMounted) {
          setConstants(response.data);
          setError(null);
        }
      } catch (err) {
        console.error('Erreur lors du chargement des constantes:', err);
        if (isMounted) {
          setError(err);
          // Utiliser des constantes de fallback
          setConstants(getFallbackConstants());
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchConstants();
    
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <ConstantsContext.Provider value={{ constants, loading, error }}>
      {children}
    </ConstantsContext.Provider>
  );
};

export const useConstantsContext = () => {
  const context = useContext(ConstantsContext);
  if (!context) {
    // Fallback si le contexte n'est pas disponible
    return { constants: null, loading: true, error: null };
  }
  return context;
};

const getFallbackConstants = () => ({
  user_roles: [
    ['CLIENT', 'Client'],
    ['TRANSPORTEUR', 'Transporteur'],
    ['ADMIN', 'Admin'],
    ['AGENT', 'Agent']
  ],
  user_status: [
    ['PENDING', 'Pending'],
    ['ACTIVE', 'Active'],
    ['SUSPENDED', 'Suspended'],
    ['BANNED', 'Banned']
  ],
  transport_domains: [
    ['HEAVY_GOODS', 'Transport de marchandises lourdes'],
    ['LIGHT_GOODS', 'Transport de colis légers'],
    ['PASSENGERS', 'Transport de personnes'],
    ['COURIER', 'Service de messagerie/express'],
    ['REFRIGERATED', 'Transport frigorifique'],
    ['DANGEROUS_GOODS', 'Transport de matières dangereuses'],
    ['CONSTRUCTION', 'Transport de matériaux de construction'],
    ['AGRICULTURE', 'Transport agricole'],
    ['MINING', 'Transport minier'],
    ['FUEL', 'Transport de carburant'],
    ['WASTE', 'Transport de déchets'],
    ['FURNITURE', 'Déménagement/Transport de meubles']
  ],
  client_types: [
    ['INDIVIDUAL', 'Individual'],
    ['BUSINESS', 'Business'],
    ['NGO', 'NGO'],
    ['MINING', 'Mining']
  ],
  verification_status: [
    ['UNVERIFIED', 'Unverified'],
    ['PENDING', 'Pending'],
    ['VERIFIED', 'Verified'],
    ['REJECTED', 'Rejected']
  ]
});

